<template>
  <H5 v-if="isMobile" />
  <PC v-else />
</template>



<script setup lang="ts">
// import { onMounted, ref } from 'vue' // Import necessary utilities from Vue
// import { useRoute } from 'vue-router' // Use if you need to access route params
// import type { QueryAttrDetailResponse } from '~/apis/back/types/QueryAttrDetailResponse'
// import type { QueryAttrInfoResponse } from '~/apis/back/types/QueryAttrInfoResponse'
// import type { ResponseQueryAttrDetailResponse } from '~/apis/back/types/ResponseQueryAttrDetailResponse'
import PC from '~/pages/desktop/activities/detail/indexDetail.vue'
import H5 from '~/pages/mobile/activities/detail/indexDetailMobile.vue'

const { getExperienceDetail, initFilter } = useExperienceDetail()

initFilter()
const experienceState = await getExperienceDetail()

const isMobile = useMobileByScreen()
const route = useRoute() // Get the current route
const { language, country, city, productSKU } = route.params
const canonicalUrl = `https://azgo.ai/ttd/${language}/${country}/${city}/${productSKU}`

const product = experienceState?.value?.experienceDetail?.data?.data

useSeoMeta({
  title: product?.specialTopicName,
  description: product?.intro?.slice(0, 160) || '',
  ogTitle: product?.specialTopicName,
  ogDescription: product?.intro?.slice(0, 160) || '',
  ogImage: product?.cover,
  ogUrl: canonicalUrl,
  ogType: 'website', // Could also be 'article' or 'website'
  twitterCard: 'summary_large_image',
  twitterTitle: product?.specialTopicName,
  twitterDescription: product?.intro?.slice(0, 160) || '',
  twitterImage: product?.cover
})


const publishedDate = '2025-04-08T00:00:00+00:00' // or dynamically from API
const modifiedDate = new Date().toISOString()

const reviewSnippet = {
  "@context": "https://schema.org",
  "@type": "AggregateRating",
  ratingValue: 4.2,
  reviewCount: 41,
  bestReating: 5,
  worstRating: 1,
  "itemReviewed": {
          "@type": "WebSite",
          "name": "Azgo.ai",
          "url": "https://azgo.ai",
          "description": "Price comparison and experience booking platform for travel experiences and activities.",
}}

const productSnippet = {
  "@context": "https://schema.org/",
  "@type": "Product",
  name: product?.specialTopicName,
  image: product?.cover ? [product?.cover] : [],
  description: product?.intro?.slice(0, 160) || '',
  sku: productSKU,
  // brand: {
  //   "@type": "Brand",
  //   name: experienceState?.value,
  // },
  offers: {
    "@type": "Offer",
    url: canonicalUrl,
    priceCurrency: "USD", // or dynamically based on product
    price: product?.prices || "0",
  },
  datePublished: publishedDate,
  dateModified: modifiedDate,
  // aggregateRating: reviewSnippet
}

const breadcrumbSnippet = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://azgo.ai/"
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "TTD",
      item: "https://azgo.ai/ttd"
    },
    {
      "@type": "ListItem",
      position: 3,
      name: language, // "EN"
      item: `https://azgo.ai/ttd/${language}`
    },
    {
      "@type": "ListItem",
      position: 4,
      name: country,
      item: `https://azgo.ai/ttd/${language}/${country}`
    },
    {
      "@type": "ListItem",
      position: 5,
      name: city,
      item: `https://azgo.ai/ttd/${language}/${country}/${city}`
    },
    {
      "@type": "ListItem",
      position: 6,
      name: productSKU,
      item: canonicalUrl
    }
  ]
}



useHead({
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl
    }
  ],
  script: [
    {
      type: 'application/ld+json',
      children: JSON.stringify(productSnippet)
    },
    {
      type: 'application/ld+json',
      children: JSON.stringify(reviewSnippet)
    },
    {
      type: 'application/ld+json',
      children: JSON.stringify(breadcrumbSnippet)
    }
  ]
})

</script>
